import { AccessToken } from '@web-shared/services/access-token';
import { authHttpService } from '@web-shared/services/http-service';
import { User } from '@web-shared/types/User.types';

import { httpService } from './http';

/** Check if existing token is valid and return user data */
export const checkUser = async () => {
  try {
    const res = await httpService.get<null, User>('/api/v2/profile/extended');
    return res.data;
  } catch (error) {
    AccessToken.clearTokens();
    throw error;
  }
};

/** Login user with PIN and coordinates */
export const loginUser = async (params: { pin: number, lat: number, lng: number }) => {
  await authHttpService.post('/api/v1/pin-auth', params);
};
